import { render } from "./PolicyBar.vue?vue&type=template&id=3fce8448"
import script from "./PolicyBar.vue?vue&type=script&lang=js"
export * from "./PolicyBar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/danilomeulens/Projects/_sandbox/simpsonbay_geneology/source/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__